import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { RefreshCw, Sparkles } from "lucide-react";
import { num, shortDate } from "@/lib/format";

export const RunBadge = ({ b }) => {
  if (!b.production_run) return null;
  return b.production_run > 1
    ? <span className="ml-2 rounded bg-amber-500/15 px-1 text-amber-400" data-testid={`batch-run-${b.batch_number}`}>Riassortimento - {b.production_run}° Tagliato</span>
    : <span className="ml-2 rounded bg-emerald-500/15 px-1 text-emerald-400" data-testid={`batch-run-${b.batch_number}`}>Prima produzione</span>;
};

export const RestockInfo = ({ product }) => {
  const body = product?.from_sheet ? { sheet_id: product.sheet_id, color: product.color } : { product_id: product?.id, color: product?.color };
  const { data } = useQuery({ queryKey: ["restock-check", JSON.stringify(body)], enabled: !!product, queryFn: async () => (await api.post("/production/restock-check", body)).data });
  if (!product || !data) return null;
  if (data.run === 1) {
    return <p className="flex items-center gap-1.5 rounded-md bg-emerald-500/10 px-3 py-2 text-xs text-emerald-400" data-testid="restock-info"><Sparkles className="h-3.5 w-3.5" />Prima produzione di questo articolo in questo colore</p>;
  }
  const last = data.previous[data.previous.length - 1];
  return (
    <p className="flex items-center gap-1.5 rounded-md bg-amber-500/10 px-3 py-2 text-xs text-amber-400" data-testid="restock-info">
      <RefreshCw className="h-3.5 w-3.5" />Riassortimento - {data.run}° Tagliato: già prodotto {data.run - 1} {data.run === 2 ? "volta" : "volte"}{last ? ` · ultimo lotto ${last.batch_number} del ${shortDate(last.created_at)} (${num(last.quantity)} capi)` : ""}
    </p>
  );
};
